import { STORAGE_KEYS } from '../../config/constants';

interface AuthData {
  user: any;
  token: string;
}

export const authStorage = {
  getAuthData: (): AuthData | null => {
    try {
      const authFlag = localStorage.getItem(STORAGE_KEYS.AUTHENTICATED);
      const userStr = localStorage.getItem(STORAGE_KEYS.USER);
      const token = localStorage.getItem(STORAGE_KEYS.TOKEN);

      if (authFlag === 'true' && userStr && token) {
        return { user: JSON.parse(userStr), token };
      }
    } catch (e) {
      console.error('Failed to parse auth data from local storage', e);
    }
    return null;
  },

  setAuthData: (user: any, token: string = 'session-token'): void => {
    try {
      localStorage.setItem(STORAGE_KEYS.AUTHENTICATED, 'true');
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
    } catch (e) {
      console.error('Failed to write auth data to local storage', e);
    }
  },

  clearAuthData: (): void => {
    try {
      localStorage.removeItem(STORAGE_KEYS.AUTHENTICATED);
      localStorage.removeItem(STORAGE_KEYS.USER);
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      sessionStorage.clear();
      
      // Clear legacy cookies as a fallback precaution
      const legacyCookies = [
        'kavithai_authenticated',
        'kavithai_user',
        'kavithai_token',
        'AUTH_SESSION_ID',
        'AUTH_SESSION_ID_LEGACY',
        'KC_RESTART',
        'KEYCLOAK_SESSION',
      ];
      legacyCookies.forEach(cookie => {
        document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
    } catch (e) {
      console.error('Failed to clean auth data', e);
    }
  }
};
